import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  FrameType_BINARY_getInstance9h62j6ssxfdm as FrameType_BINARY_getInstance,
  FrameType_TEXT_getInstance13rnlbf2papgb as FrameType_TEXT_getInstance,
  FrameType_CLOSE_getInstanceyjt6b53yjpbv as FrameType_CLOSE_getInstance,
  FrameType_PING_getInstance2m9eh67nmjf4o as FrameType_PING_getInstance,
  FrameType_PONG_getInstance34ya51qooxkd7 as FrameType_PONG_getInstance,
} from './FrameType.mjs';
import { NonDisposableHandle_instance32d73uqknj6a6 as NonDisposableHandle_instance } from './FrameCommon.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toByteArray1i3ns5jnoqlv6 as toByteArray,
  writeText19qfzm98fbm4l as writeText,
} from '../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { validateSize23lir9ygeqvey as validateSize } from './ControlFrames.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BinaryClass;
function Binary() {
  if (BinaryClass === VOID) {
    class $ extends Frame() {
      constructor(fin, data, rsv1, rsv2, rsv3) {
        return new.target.new_io_ktor_websocket_Frame_Binary_yf73xr_k$(fin, data, rsv1, rsv2, rsv3);
      }
      static new_io_ktor_websocket_Frame_Binary_yf73xr_k$(fin, data, rsv1, rsv2, rsv3) {
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        return this.new_io_ktor_websocket_Frame_fjyusq_k$(fin, FrameType_BINARY_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
      }
      static new_io_ktor_websocket_Frame_Binary_dw7hrz_k$(fin, data) {
        return this.new_io_ktor_websocket_Frame_Binary_yf73xr_k$(fin, data, false, false, false);
      }
    }
    initMetadataForClass($, 'Binary');
    BinaryClass = $;
  }
  return BinaryClass;
}
var TextClass;
function Text() {
  if (TextClass === VOID) {
    class $ extends Frame() {
      constructor(fin, data, rsv1, rsv2, rsv3) {
        return new.target.new_io_ktor_websocket_Frame_Text_sv4r43_k$(fin, data, rsv1, rsv2, rsv3);
      }
      static new_io_ktor_websocket_Frame_Text_sv4r43_k$(fin, data, rsv1, rsv2, rsv3) {
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        return this.new_io_ktor_websocket_Frame_fjyusq_k$(fin, FrameType_TEXT_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
      }
      static new_io_ktor_websocket_Frame_Text_ejsfdh_k$(fin, data) {
        return this.new_io_ktor_websocket_Frame_Text_sv4r43_k$(fin, data, false, false, false);
      }
      static new_io_ktor_websocket_Frame_Text_j2nyd2_k$(text) {
        return this.new_io_ktor_websocket_Frame_Text_ejsfdh_k$(true, toByteArray(text));
      }
    }
    initMetadataForClass($, 'Text');
    TextClass = $;
  }
  return TextClass;
}
var CloseClass;
function Close() {
  if (CloseClass === VOID) {
    class $ extends Frame() {
      constructor(data) {
        return new.target.new_io_ktor_websocket_Frame_Close_1zir9_k$(data);
      }
      static new_io_ktor_websocket_Frame_Close_1zir9_k$(data) {
        return this.new_io_ktor_websocket_Frame_fjyusq_k$(true, FrameType_CLOSE_getInstance(), data, NonDisposableHandle_instance, false, false, false);
      }
      static new_io_ktor_websocket_Frame_Close_zgly5v_k$(reason) {
        // Inline function 'io.ktor.utils.io.core.buildPacket' call
        var builder = new (Buffer())();
        builder.writeShort_vn2jsb_k$(reason.code_1);
        writeText(builder, reason.message_1);
        return this.new_io_ktor_websocket_Frame_Close_dmkrzr_k$(builder);
      }
      static new_io_ktor_websocket_Frame_Close_dmkrzr_k$(packet) {
        return this.new_io_ktor_websocket_Frame_Close_1zir9_k$(readByteArray(packet));
      }
      static new_io_ktor_websocket_Frame_Close_ddsmnf_k$() {
        return this.new_io_ktor_websocket_Frame_Close_1zir9_k$(Companion_getInstance().Empty_1);
      }
    }
    initMetadataForClass($, 'Close', $.new_io_ktor_websocket_Frame_Close_ddsmnf_k$);
    CloseClass = $;
  }
  return CloseClass;
}
var PingClass;
function Ping() {
  if (PingClass === VOID) {
    class $ extends Frame() {
      constructor(data) {
        return new.target.new_io_ktor_websocket_Frame_Ping_eh4ca3_k$(data);
      }
      static new_io_ktor_websocket_Frame_Ping_eh4ca3_k$(data) {
        return this.new_io_ktor_websocket_Frame_fjyusq_k$(true, FrameType_PING_getInstance(), data, NonDisposableHandle_instance, false, false, false);
      }
    }
    initMetadataForClass($, 'Ping');
    PingClass = $;
  }
  return PingClass;
}
var PongClass;
function Pong() {
  if (PongClass === VOID) {
    class $ extends Frame() {
      constructor(data, disposableHandle) {
        return new.target.new_io_ktor_websocket_Frame_Pong_hee4xw_k$(data, disposableHandle);
      }
      static new_io_ktor_websocket_Frame_Pong_hee4xw_k$(data, disposableHandle) {
        disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
        return this.new_io_ktor_websocket_Frame_fjyusq_k$(true, FrameType_PONG_getInstance(), data, disposableHandle, false, false, false);
      }
    }
    initMetadataForClass($, 'Pong');
    PongClass = $;
  }
  return PongClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.Empty_1 = new Int8Array(0);
      }
      byType_2g4m5x_k$(fin, frameType, data, rsv1, rsv2, rsv3) {
        var tmp;
        switch (frameType.ordinal_1) {
          case 1:
            tmp = Binary().new_io_ktor_websocket_Frame_Binary_yf73xr_k$(fin, data, rsv1, rsv2, rsv3);
            break;
          case 0:
            tmp = Text().new_io_ktor_websocket_Frame_Text_sv4r43_k$(fin, data, rsv1, rsv2, rsv3);
            break;
          case 2:
            tmp = Close().new_io_ktor_websocket_Frame_Close_1zir9_k$(data);
            break;
          case 3:
            tmp = Ping().new_io_ktor_websocket_Frame_Ping_eh4ca3_k$(data);
            break;
          case 4:
            tmp = Pong().new_io_ktor_websocket_Frame_Pong_hee4xw_k$(data, NonDisposableHandle_instance);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var FrameClass;
function Frame() {
  if (FrameClass === VOID) {
    class $ {
      static new_io_ktor_websocket_Frame_fjyusq_k$(fin, frameType, data, disposableHandle, rsv1, rsv2, rsv3) {
        Companion_getInstance();
        disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
        rsv1 = rsv1 === VOID ? false : rsv1;
        rsv2 = rsv2 === VOID ? false : rsv2;
        rsv3 = rsv3 === VOID ? false : rsv3;
        var $this = createThis(this);
        $this.fin_1 = fin;
        $this.frameType_1 = frameType;
        $this.data_1 = data;
        $this.disposableHandle_1 = disposableHandle;
        $this.rsv1__1 = rsv1;
        $this.rsv2__1 = rsv2;
        $this.rsv3__1 = rsv3;
        validateSize($this);
        return $this;
      }
      toString() {
        return 'Frame ' + this.frameType_1.toString() + ' (fin=' + this.fin_1 + ', buffer len = ' + this.data_1.length + ')';
      }
    }
    initMetadataForClass($, 'Frame');
    FrameClass = $;
  }
  return FrameClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance3acdrc353k3ou,
  Binary as Binary3tlzyfojm51s4,
  Close as Close3tx65evcwi73t,
  Ping as Ping3nta6l7sdq1r9,
  Pong as Pong3m3cas9hmc9ec,
  Text as Text3e6ukp9joohql,
};
//endregion

//# sourceMappingURL=Frame.nonJvm.mjs.map
